import * as React from 'react'
import './next.css'

export const NextIcon = (props: any) =>
<svg id="Component_27_1" data-name="Component 27 – 1" xmlns="http://www.w3.org/2000/svg"
width="11.563" height="21.599" viewBox="0 0 11.563 21.599">
  <path id="Path_447" data-name="Path 447" className="next" d="M34.7,27.876a.764.764,0,0,1-1.08,0,.764.764,0,0,1,0-1.08l9.5-9.5-9.5-9.5a.764.764,0,0,1,1.08-1.08L44.739,16.76a.764.764,0,0,1,0,1.08Z" transform="translate(-33.4 -6.5)"/>
</svg>
